import React, { PureComponent } from 'react';
import { H4 } from '@rezdy/components/Heading';
import Icon from '@rezdy/components/Icon';
import Layout from '../components/Layout';
import TextStyle from '@rezdy/components/TextStyle';
import signOut from '../actions/signOut';
import routes from '../constants/routes';
import routing from '../services/routing';
import { withTranslation, WithTranslation } from 'react-i18next';

export const context = 'signOut';

interface ISignOutRouteState {
    error?: string;
}
class SignOut extends PureComponent<WithTranslation, ISignOutRouteState> {
    state = {
        error: undefined,
    };

    async componentDidMount() {
        try {
            await signOut();
        } catch (error) {
            routing.push(routes.ERROR);
        }
    }

    render() {
        const { error } = this.state;
        if (error) {
            throw error;
        }

        const { i18n } = this.props;

        return (
            <Layout>
                <TextStyle align="center">
                    <H4>
                        {i18n.t('SIGN_OUT')} <Icon name="loader-dots" size="large" />
                    </H4>
                </TextStyle>
            </Layout>
        );
    }
}

export default withTranslation()(SignOut);
